import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import AppStoreLogo from '~/assets/app-store-logo.png'
import GooglePlayStoreLogo from '~/assets/google-play-store-logo.png'
import WebLogo from '~/assets/web-logo.png'

import './styles.scss'

const DeviceTypeCellRenderer = ({ value }: ICellRendererParams): ReactElement | null => {
  return value === 'android' ? (
    <div className="device-type-cell-renderer google-store-logo-container">
      <img alt="google store logo" className="google-store-logo" src={GooglePlayStoreLogo} />
    </div>
  ) : value === 'ios' ? (
    <div className="device-type-cell-renderer app-store-logo-container">
      <img alt="app store logo" className="app-store-logo" src={AppStoreLogo} />
    </div>
  ) : value === 'web' ? (
    <div className="device-type-cell-renderer web-logo-container">
      <img alt="web-logo" className="app-store-logo" src={WebLogo} />
    </div>
  ) : (
    <div />
  )
}

export default DeviceTypeCellRenderer
